import api from './authApi'

export const fetchAssignedBatches = async () => {
  const response = await api.get('/staff/teaching/batches')
  return response.data?.data || []
}

export const fetchStudents = async () => {
  const response = await api.get('/staff/teaching/students')
  const data = response.data
  if (data?.success && data.data) {
    return data.data
  }
  return data
}

export const fetchStudentDetail = async (studentId) => {
  const response = await api.get(`/staff/teaching/students/${studentId}`)
  const data = response.data
  if (data?.success && data.data) {
    return data.data
  }
  return data
}

export const fetchBatchDetail = async (batchId) => {
  const response = await api.get(`/staff/teaching/batches/${batchId}`)
  return response.data
}

export const createLecture = async (payload) => {
  const response = await api.post('/staff/teaching/lectures', payload)
  return response.data
}

export const startLecture = async (lectureId) => {
  const response = await api.patch(`/staff/teaching/lectures/${lectureId}/start`)
  return response.data
}

export const endLecture = async (lectureId) => {
  const response = await api.patch(`/staff/teaching/lectures/${lectureId}/end`)
  return response.data
}

export const recordAttendance = async (lectureId, attendees, options = {}) => {
  const response = await api.post(`/staff/teaching/lectures/${lectureId}/attendance`, {
    attendees,
    markComplete: options.markComplete || false,
  })
  return response.data
}

export const fetchLectureDetail = async (lectureId) => {
  const response = await api.get(`/staff/teaching/lectures/${lectureId}`)
  return response.data
}

export default {
  fetchAssignedBatches,
  fetchStudents,
  fetchStudentDetail,
  fetchBatchDetail,
  createLecture,
  startLecture,
  endLecture,
  recordAttendance,
  fetchLectureDetail,
}
